// src/elements/DescriptionList/DescriptionList.Content.tsx
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var Content = _ref => {
  let {
    children,
    className
  } = _ref;
  return /* @__PURE__ */jsx("dd", {
    className: clsx(className),
    children
  });
};
var DescriptionList_Content_default = Content;
export { DescriptionList_Content_default };